export const WISHLIST_QUERY_KEYS = {
  ALL: 'wishlist',
  SESSION_TOKEN: 'wishlist-session-token',
  LISTS: 'wishlist-lists',
  LIST: 'wishlist-list',
} as const;

export const WISHLIST_CACHE_CONFIG = {
  SESSION_TOKEN_STALE_TIME: 30 * 60 * 1000, // 30 minutes
  SESSION_TOKEN_GC_TIME: 60 * 60 * 1000, // 1 hour
} as const;

export const WISHLIST_API_PATHS = {
  BASE: '/api/wishlist',
  LISTS: '/lists',
  ITEMS: '/items',
  SESSION: '/session',
} as const;
